module.exports = __webpack_public_path__ + "fonts/f9dfe831be6d78240a299a8c9a0ad0d4.ttf";